import Swiper, { Lazy, EffectFade } from 'swiper'
Swiper.use([ Lazy, EffectFade ]);


export default {

    sliderfunction() {
        const elem = $('.environmental-slider')
        if(elem.length) {
            const sliderHome = new Swiper(elem[0], {
                speed: 1000,
                effect: 'fade',
                fadeEffect: {
                    crossFade: true
                },
                lazy: {
                    loadPrevNext: true,
                },
                touchRatio: 0,
            })
            $('[data-hover-slider]').on('mouseenter', function(){
                sliderHome.slideTo(parseInt($(this).attr('data-hover-slider')), 1000)
            })

        }
    },

    init() {
        this.sliderfunction()
    },
}
